import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Interest } from 'src/app/interfaces/interest';
import { InterestService } from 'src/app/services/interest.service';
import { LoadingService } from 'src/app/services/loading.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-interest',
  templateUrl: './interest.component.html',
  styleUrls: ['./interest.component.scss']
})
export class InterestComponent implements OnInit {
  start:number = 0;
  positions:Array<Interest> = [];
  /**
   * The Columns to be displayed
   */
  displayedColumns = ['number', 'name', 'state', 'menu'];
  /**
   * the data to be shown
   */
  dataSource: MatTableDataSource<any>;
  /**
   * The Form to fitler the Interests
   */
  filterForm: FormGroup;
  /**
   * The Filteroptions
   */
  sortOptionsState = [
    { value: "DELETED", viewValue: "Gelöscht" },
    { value: "ACTIVE", viewValue: "Aktiv" },
  ]
  /**
   * Is the Page loading
   */
  loading:boolean = true;
  /**
   * constructor
   * Init the Form 
   * load the Interest
   * @param interestService 
   * @param fb 
   * @param overlayService 
   */
  constructor(
    private interestService: InterestService,
    private fb: FormBuilder,
    private overlayService: OverlayService) {

    this.loading = true;
    this.interestService.getAllInterests().subscribe(val => {
      this.dataSource = new MatTableDataSource(val);
      this.positions = val.sort((a, b) => a.priority - b.priority);
      console.log(val.sort((a, b) => a.priority - b.priority))
      this.loading = false;
    })
    this.filterForm = this.fb.group({
      filterState: [[]],
      searchTerm: ['']
    })
  }
/**
 * ngOnInit
 */
  ngOnInit() {
  }
  /**
   * Filter the interests via the State
   */
  filterInterests() {
    this.loading = true;
    if (this.filterForm.value.filterState != '') {
      this.interestService.searchForInterests(String(this.filterForm.value.filterState)).subscribe(val => {
        this.dataSource = new MatTableDataSource(val);

        this.positions = val.sort((a, b) => a.priority - b.priority);
        const filterValue = this.filterForm.value.searchTerm;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        this.loading = false;
      })
    } else {
      const filterValue = this.filterForm.value.searchTerm;
      this.dataSource.filter = filterValue.trim().toLowerCase();
      this.loading = false;
    }
  }
  /**
   * Reset the Filter
   */
  resetFilter() {
    this.filterForm.reset();
    this.interestService.getAllInterests().subscribe(val => {
      this.dataSource = new MatTableDataSource(val);
      this.positions = val.sort((a, b) => a.priority - b.priority);
    })
  }
  /**
   * Delete an Interest
   * @param interest 
   */
  delteInterest(interest: Interest) {
    this.interestService.deleteInterest(interest).subscribe(() => {
      this.overlayService.openSnackBar("Interesse erfolgreich gelöscht!")
    })
  }
  /**
   * Search for the Event when the user presses enter
   * @param event 
   */
  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterInterests()
    }
  }

    /**
   * Change the pos via the Drag and Drop
   * @param event 
   */
    drop(event: CdkDragDrop<string[]>) {
      moveItemInArray(this.positions, event.previousIndex, event.currentIndex);
    }
    /**
     * Move the Event one Pos to the Top
     * @param event 
     */
    moveOnePositionUP(event: any) {
      moveItemInArray(this.positions, event, event - 1);
    }
    /**
     * Move the Event one Pos to the end
     * @param event 
     */
    moveOnePositionDown(event: any) {
      moveItemInArray(this.positions, event, event + 1);
    }
    /**
     * Move the Event to the first Pos
     * @param event 
     */
    moveOnePositionTop(event: any) {
      moveItemInArray(this.positions, event, 0);
    }
    /**
     * Move the Event to the last Pos
     * @param event 
     */
    moveOnePositionLast(event: any) {
      moveItemInArray(this.positions, event, this.positions.length - 1);
    }
    /**
     * Update the Interests Prio
     */
    saveChanges(){
      this.positions.forEach((element, index) => {
        element.priority = this.start + index;
        this.interestService.editInterest(element).subscribe(val => {
          this.overlayService.openSnackBar("Interesse erfolgreich bearbeitet!");
        })
      });
    }
}
